module.exports = require("path-to-regexp");


//////////////////
// WEBPACK FOOTER
// external "path-to-regexp"
// module id = 50
// module chunks = 0 1 2 3 4 5 6 7 19 20